export default "__VITE_ASSET__DPOmTyA3__"